'use strict';

exports.__esModule = true;
exports.createConnect = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createConnect = exports.createConnect = function createConnect(store) {
  return function () {
    for (var _len = arguments.length, configs = Array(_len), _key = 0; _key < _len; _key++) {
      configs[_key] = arguments[_key];
    }

    return function (WrappedComponent) {
      var ConnectedComponent = _reactRedux.connect.apply(undefined, configs)(WrappedComponent);

      var ConnectWrapper = function (_Component) {
        _inherits(ConnectWrapper, _Component);

        function ConnectWrapper() {
          _classCallCheck(this, ConnectWrapper);

          return _possibleConstructorReturn(this, _Component.apply(this, arguments));
        }

        ConnectWrapper.prototype.render = function render() {
          if (this.context.store) {
            return _react2['default'].createElement(ConnectedComponent, this.props);
          }

          return _react2['default'].createElement(
            _reactRedux.Provider,
            { store: store },
            _react2['default'].createElement(ConnectedComponent, this.props)
          );
        };

        return ConnectWrapper;
      }(_react.Component);

      var contextTypes = ConnectedComponent.contextTypes || {};
      ConnectWrapper.contextTypes = _extends({}, contextTypes, { store: _propTypes.object });
      return ConnectWrapper;
    };
  };
};

exports['default'] = createConnect;